module.exports = __webpack_public_path__ + "img/coin.96df848b.gif";